module.exports = __webpack_public_path__ + "img/folder-minus.5148901d.svg";